import React, { PropsWithChildren, useState } from 'react';

import { v4 as uuidv4 } from 'uuid';

import { SearchViewModel } from '@api/index';
import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import { DateType } from '@utils/dateUtil';

import { createGenericContext } from '../generateContext';

type ContextInterface = {
  location: SearchViewModel;
  setLocation: React.Dispatch<React.SetStateAction<SearchViewModel>>;
  activeLocation: SearchViewModel;
  setActiveLocation: React.Dispatch<React.SetStateAction<SearchViewModel>>;
  startDate: DateType | null;
  endDate: DateType | null;
  setDates: React.Dispatch<
    React.SetStateAction<{
      startDate: DateType | null;
      endDate: DateType | null;
    }>
  >;
  hotelRoomsList: Array<ListingSearchRoomInterface>;
  setHotelRoomsList: React.Dispatch<
    React.SetStateAction<ListingSearchRoomInterface[]>
  >;
  isHotelDateSelected: boolean;
  setHotelDateSelection: React.Dispatch<React.SetStateAction<boolean>>;

  isFetchedItems: boolean;
  setIsFetchedItems: React.Dispatch<React.SetStateAction<boolean>>;
  isStickySearch: boolean;
  setIsStickySearch: React.Dispatch<React.SetStateAction<boolean>>;

  isLocationEntered: boolean;
  setIsLocationEntered: React.Dispatch<React.SetStateAction<boolean>>;
};

const [useSearchBarContext, SearchBarContextProvider] =
  createGenericContext<ContextInterface>();

const SearchBarProvider = (props: PropsWithChildren): JSX.Element => {
  const [hotelRoomsList, setHotelRoomsList] = useState<
    Array<ListingSearchRoomInterface>
  >([
    {
      title: '1. Oda',
      id: uuidv4(),
      adultCount: 2,
      childrenList: [],
      closable: true,
      error: false,
      key: '1',
    },
  ]);

  const [location, setLocation] = useState<SearchViewModel>({
    id: 0,
    text: '',
    url: '',
  });

  const [activeLocation, setActiveLocation] = useState<SearchViewModel>({
    id: 0,
    text: '',
    url: '',
  });
  const [{ startDate, endDate }, setDates] = useState<{
    startDate: DateType | null;
    endDate: DateType | null;
  }>({ startDate: null, endDate: null });
  const [isFetchedItems, setIsFetchedItems] = useState<boolean>(false);
  const [isHotelDateSelected, setHotelDateSelection] = useState<boolean>(false);

  const [isStickySearch, setIsStickySearch] = useState<boolean>(false);

  const [isLocationEntered, setIsLocationEntered] = useState<boolean>(true);

  return (
    <SearchBarContextProvider
      value={{
        hotelRoomsList,
        setHotelRoomsList,

        location,
        setLocation,
        startDate,
        endDate,
        setDates,
        isHotelDateSelected,
        setHotelDateSelection,
        activeLocation,
        setActiveLocation,
        isFetchedItems,
        setIsFetchedItems,
        isStickySearch,
        setIsStickySearch,
        isLocationEntered,
        setIsLocationEntered,
      }}
    >
      {props.children}
    </SearchBarContextProvider>
  );
};
export { useSearchBarContext, SearchBarProvider };
